import LoadingButton from "@mui/lab/LoadingButton";
import CircularProgress from "@mui/material/CircularProgress";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { isBrowser } from "react-device-detect";
import { toast } from "react-toastify";
import useCreateAcount from "../../../components/Hooks/useCreateAcount";
import { useAccountV2 } from "../../../components/Hooks/useRegisterV2";
import { useNewComerStore } from "../../../store/newComerStore";

// eslint-disable-next-line no-empty-pattern
export const CalculatePoint = ({}: { setTab: any }) => {
  const { accountV2, isLoading, refetch: refreshAccount } = useAccountV2();
  const newComerData = useNewComerStore((state: any) => state.newComerData);
  const updateNewComerData = useNewComerStore(
    (state: any) => state.updateNewComerData
  );

  const [loading, setLoading] = useState<boolean>(true);

  const { mutateAsync: registerAsync } = useCreateAcount();

  const handleRegister = () => {
    setLoading(true);
    registerAsync()
      .then(async (rs) => {
        if (rs?.data) {
          // setTab(2);
          handleContinueRegister();
        }
      })
      .catch((err: any) => {
        toast.error(err, { autoClose: 2000 });
      });
  };

  const handleContinueRegister = async () => {
    refreshAccount();
    // await claimFirstEggAsync();
    // tele.openTelegramLink("https://t.me/seedupdates");
  };

  useEffect(() => {
    updateNewComerData(accountV2?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountV2]);

  useEffect(() => {
    if (newComerData) {
      setLoading(false);
    }
  }, [newComerData]);

  // const [luckyProgress, setLuckyProgress] = useState<boolean>(false);

  // const checkWelcomeRewardProgess = async () => {
  //   await sleep(3000);
  //   setLuckyProgress(true);
  // };

  // const [telegramAgeProgress, setTelegramAgeProgress] =
  //   useState<boolean>(false);
  // const checkTelegramAge = async () => {
  //   await sleep(6000);
  //   setTelegramAgeProgress(true);
  // };

  // const [checkAll, setCheckAll] = useState<boolean>(false);
  // const checkTelePremiumProgess = async () => {
  //   await sleep(9000);
  //   setCheckAll(true);
  // };

  // useEffect(() => {
  //   checkWelcomeRewardProgess();
  //   checkTelegramAge();
  //   checkTelePremiumProgess();
  // }, []);

  const imageElement = new Image();
  imageElement.src = "/images/register_bg.png";

  const [imageLoad, setImageLoad] = useState<boolean>(false);

  if (loading) {
    return (
      <div className=" backdrop-blur-sm fixed inset-0 flex items-center justify-center z-50 bg-[#F2FFE0]">
        <CircularProgress style={{ color: "black" }} />
      </div>
    );
  }

  return (
    <div className="flex flex-col max-w-md mx-auto items-center bg-white min-h-screen h-screen relative">
      <div
        className="w-full z-20 relative overflow-hidden flex flex-col items-center justify-center"
        style={{
          height: isBrowser ? "55%" : imageLoad ? "auto" : "55%",
          maxHeight: !isBrowser ? "60%" : imageLoad ? "auto" : "65%",
        }}
      >
        <div className="flex flex-col items-center justify-center">
          <div className="absolute top-8">
            <svg
              width="103"
              height="29"
              viewBox="0 0 103 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M96.5221 21.2493C97.7522 21.2493 98.6985 20.9181 99.3609 20.2557C100.023 19.5933 100.354 18.6471 100.354 17.4169V11.8683C100.354 11.2661 100.268 10.7285 100.096 10.2553C99.9244 9.7822 99.6706 9.38218 99.3351 9.05529C99.0082 8.71979 98.6082 8.46602 98.135 8.29397C97.6619 8.12192 97.1242 8.03589 96.5221 8.03589H87.1152V21.2493H96.5221ZM87.1152 23.8946V5.39062H96.5221C97.5114 5.39062 98.4017 5.54547 99.1931 5.85516C99.9932 6.15625 100.673 6.59067 101.232 7.15844C101.8 7.7176 102.234 8.3972 102.535 9.19723C102.845 9.99726 103 10.8876 103 11.8683V17.4169C103 18.3976 102.845 19.288 102.535 20.088C102.234 20.888 101.8 21.5719 101.232 22.1397C100.673 22.6989 99.9932 23.1333 99.1931 23.443C98.4017 23.7441 97.5114 23.8946 96.5221 23.8946H87.1152Z"
                fill="black"
              />
              <path
                d="M71.1533 5.39062H84.6377V8.03589H71.1533V13.3264H83.0506V15.9717H71.1533V21.2493H84.6377V23.8946H71.1533V5.39062Z"
                fill="#63EF02"
              />
              <path
                d="M55.1914 5.39062H68.6758V8.03589H55.1914V13.3264H67.0887V15.9717H55.1914V21.2493H68.6758V23.8946H55.1914V5.39062Z"
                fill="#63EF02"
              />
              <path
                d="M41.0877 15.9717C40.7263 15.9717 40.3822 15.9029 40.0554 15.7652C39.7371 15.619 39.4575 15.4297 39.2166 15.1975C38.9757 14.9566 38.7865 14.677 38.6488 14.3587C38.5112 14.0318 38.4424 13.6877 38.4424 13.3264V8.03589C38.4424 7.67459 38.5112 7.33479 38.6488 7.0165C38.7865 6.6896 38.9757 6.41002 39.2166 6.17775C39.4575 5.93688 39.7371 5.74763 40.0554 5.60999C40.3822 5.46375 40.7263 5.39062 41.0877 5.39062H52.7139V8.03589H41.0877V13.3264H50.0687C50.43 13.3264 50.7698 13.3952 51.0881 13.5329C51.4149 13.6705 51.6988 13.8598 51.9397 14.1007C52.1806 14.3415 52.3698 14.6254 52.5075 14.9523C52.6451 15.2706 52.7139 15.6104 52.7139 15.9717V21.2493C52.7139 21.6106 52.6451 21.9547 52.5075 22.2816C52.3698 22.5999 52.1806 22.8795 51.9397 23.1204C51.6988 23.3612 51.4149 23.5505 51.0881 23.6881C50.7698 23.8258 50.43 23.8946 50.0687 23.8946H38.4424V21.2493H50.0687V15.9717H41.0877Z"
                fill="black"
              />
              <path
                d="M15.6474 1L4.13179 7.83234M15.6474 1V2.33629M15.6474 1L24.9809 8.10282M4.13179 7.83234L0.999023 11.561M4.13179 7.83234L7.0053 11.9921M0.999023 11.561L1.60397 17.639M0.999023 11.561L2.33855 17.2511M1.60397 17.639L8.31386 24.2052C8.37742 24.2674 8.44907 24.3208 8.52687 24.3639L15.6474 28.3078M1.60397 17.639L2.33855 17.2511M15.6474 28.3078L21.4868 24.382C21.5688 24.3269 21.6421 24.2599 21.7042 24.1831L27.1414 17.4666M15.6474 28.3078L9.74917 20.4194M15.6474 28.3078L21.9129 20.1176M27.1414 17.4666L27.9341 12.8232C27.9667 12.6325 27.9427 12.4365 27.8652 12.2592L26.6828 9.5553C26.6152 9.40067 26.5092 9.26586 26.3749 9.16365L24.9809 8.10282M27.1414 17.4666L23.2525 12.2507M27.1414 17.4666L21.9129 20.1176M15.6474 2.33629L23.2525 12.2507M15.6474 2.33629L15.9931 15.0526M15.6474 2.33629L7.0053 11.9921M23.2525 12.2507L24.9809 8.10282M23.2525 12.2507L15.9931 15.0526M21.9129 20.1176L9.74917 20.4194M21.9129 20.1176L15.9931 15.0526M9.74917 20.4194L2.33855 17.2511M9.74917 20.4194L15.9931 15.0526M2.33855 17.2511L7.0053 11.9921M15.9931 15.0526L7.0053 11.9921"
                stroke="url(#paint0_linear_12943_1559)"
                stroke-width="1.32165"
                stroke-linejoin="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_12943_1559"
                  x1="15.626"
                  y1="1"
                  x2="15.626"
                  y2="28.3078"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#46F503" />
                  <stop offset="1" stop-color="#77EB02" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <img
            src={imageElement.src}
            onLoad={() => setImageLoad(true)}
            className={clsx("w-full object-cover mt-8")}
            alt="welcome-banner"
          ></img>
        </div>
      </div>

      <div className="z-30 w-full px-4 pb-4 flex flex-col items-center relative">
        <svg
          width="187"
          height="82"
          viewBox="0 0 187 82"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.2192 8.4952C2.2192 7.62985 2.52626 6.89011 3.14038 6.276C3.7545 5.66188 4.49423 5.35482 5.35958 5.35482C5.88996 5.35482 6.39242 5.49439 6.86696 5.77354C7.36942 6.05268 7.88584 6.52723 8.41622 7.19717L22.0664 24.9927V5.68979H27.8028V32.1946C27.8028 33.0599 27.4958 33.7997 26.8816 34.4138C26.2675 35.0279 25.5278 35.335 24.6624 35.335C24.1321 35.335 23.6157 35.1954 23.1132 34.9163C22.6386 34.6371 22.1362 34.1626 21.6058 33.4926L7.95563 15.6971V35H2.2192V8.4952ZM51.9543 5.68979V10.84H37.8435V17.7488H49.6095V22.8991H37.8435V29.8498H51.9543V35H35.9174C33.3772 35 32.1071 33.7299 32.1071 31.1897V9.50012C32.1071 6.9599 33.3772 5.68979 35.9174 5.68979H51.9543ZM71.7017 8.16022C71.9809 7.3507 72.3577 6.73659 72.8323 6.31787C73.3347 5.89915 73.9907 5.68979 74.8002 5.68979C75.6098 5.68979 76.2518 5.89915 76.7263 6.31787C77.2009 6.73659 77.5777 7.3507 77.8569 8.16022L83.1746 24.7833L89.1204 5.68979H95.3593L86.2312 32.7808C85.98 33.5066 85.5892 34.0649 85.0588 34.4557C84.5564 34.8186 83.9841 35 83.3421 35C82.7 35 82.1138 34.8186 81.5835 34.4557C81.0531 34.0649 80.6762 33.5066 80.4529 32.7808L74.8002 16.2415L69.1476 32.7808C68.8963 33.5066 68.5055 34.0649 67.9751 34.4557C67.4448 34.8186 66.8586 35 66.2165 35C65.5745 35 64.9883 34.8186 64.4579 34.4557C63.9555 34.0649 63.5786 33.5066 63.3274 32.7808L54.1994 5.68979H60.4382L66.384 24.7833L71.7017 8.16022ZM126.497 5.68979V10.84H112.387V17.7488H124.153V22.8991H112.387V29.8498H126.497V35H110.461C107.92 35 106.65 33.7299 106.65 31.1897V9.50012C106.65 6.9599 107.92 5.68979 110.461 5.68979H126.497ZM135.735 19.2144H142.56C143.286 19.2144 143.914 19.1027 144.444 18.8794C144.975 18.6282 145.421 18.3071 145.784 17.9163C146.175 17.5255 146.454 17.0789 146.622 16.5764C146.817 16.074 146.915 15.5715 146.915 15.0691C146.915 14.5387 146.817 14.0223 146.622 13.5198C146.454 13.0173 146.175 12.5707 145.784 12.1799C145.421 11.7612 144.975 11.4402 144.444 11.2169C143.914 10.9656 143.286 10.84 142.56 10.84H135.735V19.2144ZM147.25 35L140.006 24.4065H135.735V35H129.999V9.50012C129.999 6.9599 131.269 5.68979 133.809 5.68979H142.979C144.626 5.68979 146.049 5.96894 147.25 6.52723C148.478 7.0576 149.497 7.76942 150.306 8.66269C151.116 9.52803 151.716 10.519 152.107 11.6356C152.526 12.7522 152.735 13.8827 152.735 15.0272C152.735 16.0321 152.595 17.0091 152.316 17.9582C152.065 18.8794 151.674 19.7308 151.144 20.5124C150.613 21.294 149.944 21.9779 149.134 22.5641C148.352 23.1503 147.417 23.5969 146.329 23.904L153.865 35H147.25ZM166.57 24.4065H175.028L170.799 14.106L166.57 24.4065ZM167.533 8.2021C167.84 7.47632 168.231 6.82033 168.705 6.23412C169.18 5.64792 169.878 5.35482 170.799 5.35482C171.274 5.35482 171.678 5.43856 172.013 5.60605C172.348 5.77354 172.641 5.99685 172.893 6.276C173.144 6.52723 173.353 6.82033 173.521 7.1553C173.716 7.49028 173.898 7.83921 174.065 8.2021L185.663 35H179.341L177.122 29.5567H164.476L162.257 35H155.935L167.533 8.2021Z"
            fill="#0E1504"
          />
          <path
            d="M5.53311 67.3606H10.3857C10.8788 67.3606 11.3128 67.2915 11.6876 67.1535C12.0624 67.0154 12.3681 66.828 12.6048 66.5913C12.8613 66.3546 13.0487 66.0883 13.167 65.7924C13.3051 65.4965 13.3742 65.1907 13.3742 64.8751C13.3742 64.5595 13.315 64.2537 13.1966 63.9579C13.0783 63.662 12.8909 63.3957 12.6344 63.159C12.3977 62.9222 12.092 62.7349 11.7172 62.5968C11.3621 62.4587 10.9479 62.3896 10.4744 62.3896H5.53311V67.3606ZM5.53311 58.8094H9.85308C10.6816 58.8094 11.3029 58.553 11.7172 58.0401C12.1314 57.5272 12.3385 56.965 12.3385 56.3535C12.3385 55.742 12.1216 55.1897 11.6876 54.6965C11.2733 54.1837 10.6323 53.9272 9.76432 53.9272H5.53311V58.8094ZM10.1194 50.2878C11.1846 50.2878 12.1117 50.4456 12.9007 50.7612C13.6898 51.0768 14.3407 51.501 14.8536 52.0336C15.3862 52.5464 15.7807 53.1382 16.0372 53.8089C16.3133 54.4598 16.4514 55.1305 16.4514 55.8209C16.4514 56.6297 16.2739 57.4187 15.9188 58.188C15.5637 58.9573 15.041 59.5984 14.3506 60.1113C15.3763 60.6242 16.1555 61.3343 16.6881 62.2417C17.2207 63.1491 17.487 64.1058 17.487 65.1118C17.487 65.8417 17.3489 66.5617 17.0728 67.2718C16.7966 67.9622 16.3725 68.5836 15.8004 69.1359C15.2481 69.6882 14.5478 70.1419 13.6996 70.497C12.8514 70.8323 11.8651 71 10.7407 71H4.11285C2.35724 71 1.47944 70.1025 1.47944 68.3074V52.9804C1.47944 51.1853 2.37697 50.2878 4.17203 50.2878H10.1194ZM50.5673 50.2878V53.9272H40.5959V58.8094H48.9104V62.4488H40.5959V67.3606H50.5673V71H39.2348C37.4397 71 36.5422 70.1025 36.5422 68.3074V52.9804C36.5422 51.1853 37.4397 50.2878 39.2348 50.2878H50.5673ZM88.3705 58.9573C89.0412 58.9573 89.5541 59.1349 89.9092 59.4899C90.284 59.845 90.4714 60.3579 90.4714 61.0286C90.4714 62.4883 90.1853 63.8592 89.6133 65.1414C89.0609 66.4236 88.3015 67.548 87.3349 68.5145C86.3881 69.4614 85.2736 70.211 83.9914 70.7633C82.7092 71.3156 81.3383 71.5918 79.8785 71.5918C78.3991 71.5918 77.0084 71.3058 75.7065 70.7337C74.4243 70.1419 73.2901 69.3529 72.3038 68.3666C71.3372 67.3803 70.5679 66.2165 69.9959 64.8751C69.4435 63.5337 69.1674 62.1135 69.1674 60.6143C69.1674 59.1151 69.4534 57.7047 70.0255 56.3831C70.5975 55.0615 71.3668 53.9075 72.3334 52.9212C73.3197 51.9152 74.4638 51.1262 75.7657 50.5541C77.0873 49.9821 78.4879 49.696 79.9673 49.696C81.5257 49.696 82.9755 50.0116 84.3169 50.6429C85.6582 51.2544 86.8319 52.0927 87.8379 53.1579L84.7015 55.7617C84.09 55.1305 83.3799 54.6374 82.5711 54.2823C81.7821 53.9272 80.9142 53.7497 79.9673 53.7497C79.0599 53.7497 78.2018 53.9272 77.3931 54.2823C76.5843 54.6374 75.8742 55.1305 75.2627 55.7617C74.6512 56.3732 74.1679 57.1031 73.8128 57.9513C73.4775 58.7798 73.3098 59.6675 73.3098 60.6143C73.3098 61.5612 73.4775 62.4587 73.8128 63.3069C74.1679 64.1354 74.6413 64.8652 75.2331 65.4965C75.8446 66.108 76.5449 66.6011 77.3339 66.9759C78.1427 67.331 79.0007 67.5085 79.9081 67.5085C80.6577 67.5085 81.3679 67.3902 82.0385 67.1535C82.7289 66.897 83.3503 66.5518 83.9026 66.1178C84.455 65.6839 84.9382 65.171 85.3525 64.5792C85.7667 63.9677 86.0725 63.3069 86.2697 62.5968H80.6183V58.9573H88.3705ZM113.907 50.2878V71H109.853V50.2878H113.907ZM133.815 52.2703C133.815 51.6588 134.032 51.136 134.466 50.7021C134.9 50.2681 135.423 50.0511 136.034 50.0511C136.409 50.0511 136.764 50.1497 137.1 50.347C137.455 50.5442 137.82 50.8796 138.194 51.353L147.84 63.9283V50.2878H151.894V69.0175C151.894 69.6291 151.677 70.1518 151.243 70.5858C150.809 71.0197 150.286 71.2367 149.675 71.2367C149.3 71.2367 148.935 71.1381 148.58 70.9408C148.245 70.7436 147.89 70.4082 147.515 69.9348L137.869 57.3595V71H133.815V52.2703ZM171.328 55.7617C171.328 54.6176 171.545 53.6609 171.979 52.8916C172.433 52.1223 172.995 51.501 173.665 51.0275C174.356 50.5541 175.105 50.2188 175.914 50.0215C176.743 49.8045 177.542 49.696 178.311 49.696C179.79 49.696 181.073 50.0116 182.157 50.6429C183.262 51.2544 184.179 52.0336 184.909 52.9804L181.832 55.1996C181.437 54.7261 180.934 54.3119 180.323 53.9568C179.731 53.6018 179.041 53.4242 178.252 53.4242C177.936 53.4242 177.611 53.4637 177.275 53.5426C176.94 53.6018 176.624 53.7201 176.328 53.8976C176.052 54.0752 175.825 54.302 175.648 54.5782C175.47 54.8544 175.382 55.1996 175.382 55.6138C175.382 56.0083 175.47 56.3634 175.648 56.679C175.845 56.9749 176.121 57.2511 176.476 57.5075C176.831 57.7442 177.265 57.9809 177.778 58.2176C178.291 58.4346 178.873 58.6615 179.524 58.8982C180.076 59.1151 180.678 59.3716 181.329 59.6675C182 59.9634 182.621 60.3579 183.193 60.851C183.765 61.3244 184.239 61.9261 184.613 62.6559C185.008 63.3858 185.205 64.2932 185.205 65.3781C185.205 66.5419 184.978 67.5282 184.525 68.337C184.091 69.126 183.519 69.7671 182.808 70.2603C182.118 70.7337 181.349 71.069 180.5 71.2663C179.672 71.4833 178.863 71.5918 178.074 71.5918C176.476 71.5918 175.096 71.2466 173.932 70.5562C172.788 69.8658 171.782 68.988 170.914 67.9228L173.961 65.7036C174.415 66.2559 174.987 66.7589 175.678 67.2126C176.388 67.6466 177.196 67.8636 178.104 67.8636C178.439 67.8636 178.784 67.8241 179.139 67.7452C179.494 67.6663 179.82 67.5381 180.116 67.3606C180.431 67.183 180.688 66.9463 180.885 66.6504C181.082 66.3348 181.181 65.96 181.181 65.5261C181.181 65.0921 181.073 64.7173 180.856 64.4017C180.658 64.0663 180.372 63.7705 179.997 63.514C179.642 63.2379 179.218 62.9913 178.725 62.7743C178.252 62.5573 177.729 62.3403 177.157 62.1233C176.526 61.8669 175.865 61.5907 175.174 61.2949C174.484 60.999 173.853 60.6143 173.281 60.1409C172.709 59.6675 172.235 59.0856 171.861 58.3952C171.505 57.685 171.328 56.8072 171.328 55.7617Z"
            fill="#0E1504"
          />
        </svg>
        {/* <div
          className={clsx(
            "w-full flex flex-col gap-2 lsm:gap-4 text-[14px] font-semibold text-[#0E1504]",
            isBrowser ? "mt-[10px]" : "mt-[15px] lsm:mt-[30px]"
          )}
        >
          <div className="flex flex-col gap-[7px]">
            <div className="flex items-center justify-between">
              <span className="font-[400]">Welcome Rewards</span>
              {newComerData && newComerData?.newcomer_event_boost_duration && (
                <div
                  className={clsx(
                    "flex items-center justify-between gap-1 transition-all duration-300 ease-linear",
                    luckyProgress
                      ? "translate-x-0 opacity-100"
                      : "translate-x-10 opacity-0"
                  )}
                >
                  <span className="text-[18px] font-[500]">
                    {newComerData?.newcomer_event_boost_duration}h x4 Speed
                  </span>
                  <img
                    src="/images/startup-speed.png"
                    className="w-[18px] h-[18px]"
                    alt="startup"
                  ></img>
                </div>
              )}
            </div>
            <div className="relative h-[10px] rounded-2xl bg-[#D2DCC3]">
              <div
                id="welcome-reward"
                className="bg-[#61A700] h-[10px] rounded-2xl absolute inset-0 loadingStartUp"
              />
            </div>
          </div>

          {newComerData && newComerData?.age && (
            <div className="flex flex-col gap-[7px]">
              <div className="flex items-center justify-between">
                <span className="font-[400]">
                  Telegram Ages Bonus ({newComerData?.age} year ago)
                </span>
                <div
                  className={clsx(
                    "flex items-center justify-between gap-1 transition-all duration-300 ease-linear",
                    telegramAgeProgress
                      ? "translate-x-0 opacity-100"
                      : "translate-x-10 opacity-0"
                  )}
                >
                  <span className="text-[18px] font-[500]">
                    +{newComerData?.age}
                  </span>
                  <img
                    src="/images/icons/token_icon.png"
                    className="w-[22px] h-[22px]"
                    alt="seed"
                  ></img>
                </div>
              </div>
              <div className="relative h-[10px] rounded-2xl bg-[#D2DCC3]">
                <div
                  id="tele-premium"
                  className={clsx(
                    "bg-[#61A700] h-[10px] rounded-2xl absolute inset-0",
                    luckyProgress ? "loadingStartUp" : "w-0"
                  )}
                />
              </div>
            </div>
          )}

          {newComerData && newComerData?.bonus_premium > 0 && (
            <div className="flex flex-col gap-[7px]">
              <div className="flex items-center justify-between">
                <span className="font-[400]">Telegram Premium</span>
                <div
                  className={clsx(
                    "flex items-center justify-between gap-1 transition-all duration-300 ease-linear",
                    checkAll
                      ? "translate-x-0 opacity-100"
                      : "translate-x-10 opacity-0"
                  )}
                >
                  <span className="text-[18px] font-[500]">
                    +{newComerData?.bonus_premium / 10 ** 9}
                  </span>
                  <img
                    src="/images/icons/token_icon.png"
                    className="w-[22px] h-[22px]"
                    alt="startup"
                  ></img>
                </div>
              </div>
              <div className="relative h-[10px] rounded-2xl bg-[#D2DCC3]">
                <div
                  id="tele-premium"
                  className={clsx(
                    "bg-[#61A700] h-[10px] rounded-2xl absolute inset-0",
                    telegramAgeProgress ? "loadingStartUp" : "w-0"
                  )}
                />
              </div>
            </div>
          )}
        </div> */}
      </div>

      <LoadingButton
        loading={isLoading}
        onClick={() => handleRegister()}
        className="btn-hover z-30 fixed bottom-[20px] text-[16px] left-4 right-4 capitalize font-extrabold text-white py-[16px] rounded-[38px] bg-gradient-to-r from-[#61A700] to-[#61A700]"
      >
        {"Continue"}
      </LoadingButton>
    </div>
  );
};
